export function getChannelServerGroup(channel: { settings?: unknown }): string {
  const settings = channel.settings && typeof channel.settings === 'object' && !Array.isArray(channel.settings)
    ? channel.settings as Record<string, unknown>
    : {}
  const byoc = settings.byoc && typeof settings.byoc === 'object' && !Array.isArray(settings.byoc)
    ? settings.byoc as Record<string, unknown>
    : {}

  // Image releases do not identify the server group used for preview routing.
  for (const candidate of [byoc.serverGroup, settings.serverGroup]) {
    if (typeof candidate !== 'string') continue
    const serverGroup = candidate.replace(/[^a-zA-Z0-9]/g, '').toLowerCase()
    if (serverGroup) return serverGroup
  }

  return 'prod'
}
